import { Avatar, Box, Chip, Stack, Tooltip, Typography, Table, TableBody, TableCell, TableRow, TableHead } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getFixedValue, TOOLTIP_STYLES, trunCateString } from "../../utils/constant";

const UltimateDiscoverResults = ({ results, platform }) => {
  const navigate = useNavigate();

  if (!results || results.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography color="text.secondary">No results found</Typography>
      </Box>
    );
  }

  const isInstagram = platform?.toLowerCase() === 'instagram' || platform?.toLowerCase() !== 'youtube';
  const isYoutube = platform?.toLowerCase() === 'youtube';

  return (
    <Box sx={{ width: '100%', overflowX: 'auto', background: 'white' }}>
      <Table stickyHeader sx={{ tableLayout: 'auto', width: '100%', minWidth: '800px' }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ position: "sticky", top: 0, zIndex: 10, background: '#DBECFF !important', height: "50px", padding: '16px', border: '0px', width: "120px", fontWeight: 600 }}>Profiles</TableCell>
            <TableCell sx={{ position: "sticky", top: 0, zIndex: 10, background: '#DBECFF !important', height: "50px", padding: '16px', border: '0px', width: "40px", fontWeight: 600 }}>{isInstagram ? 'Followers' : 'Subscribers'}</TableCell>
            <TableCell sx={{ position: "sticky", top: 0, zIndex: 10, background: '#DBECFF !important', height: "50px", padding: '16px', border: '0px', width: "50px", fontWeight: 600 }}>Avg Likes</TableCell>
            <TableCell sx={{ position: "sticky", top: 0, zIndex: 10, background: '#DBECFF !important', height: "50px", padding: '16px', border: '0px', width: "60px", fontWeight: 600 }}>{isInstagram ? 'Reel views' : 'Avg views'}</TableCell>
            {isYoutube && <TableCell sx={{ position: "sticky", top: 0, zIndex: 10, background: '#DBECFF !important', height: "50px", padding: '16px', border: '0px', width: "40px", fontWeight: 600 }}>Avg Comment</TableCell>}
            {isInstagram && <TableCell sx={{ position: "sticky", top: 0, zIndex: 10, background: '#DBECFF !important', height: "50px", padding: '16px', border: '0px', width: "30px", fontWeight: 600 }}>ER</TableCell>}
            <TableCell sx={{ position: "sticky", top: 0, zIndex: 10, background: '#DBECFF !important', height: "50px", padding: '16px', border: '0px', width: "80px", fontWeight: 600 }}>Location</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {results.map((row, index) => {
            const followerCount = row?.followers || row?.followersCount;
            const avgLikes = row?.Engagement?.posts?.avg_likes || row?.avgLikes || 0;
            const avgViews = row?.Engagement?.reels?.avg_views || row?.Engagement?.posts?.avg_views || row?.avgViews || 0;
            const avgComments = row?.Engagement?.posts?.avg_comments || row?.avgComments || 0;
            const er = row?.engagementRate || row?.Engagement?.posts?.engagement_rate;
            
            const locationStr = [
              row.location?.city,
              row.location?.state,
              row.location?.country
            ].filter(Boolean).join(', ') || (typeof row.location === 'string' ? row.location : '');

            // Rows without an id can't open a details page. Keep them visible but render
            // them in a disabled state so users can tell they're not clickable.
            const isDisabled = !row.id;

            return (
              <Tooltip
                key={`${row.id}-${index}`}
                componentsProps={TOOLTIP_STYLES}
                title={isDisabled ? 'Profile details unavailable' : ''}
                arrow={true}
              >
              <TableRow
                hover={!isDisabled}
                sx={{
                  height: '60px',
                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                  opacity: isDisabled ? 0.55 : 1,
                  backgroundColor: isDisabled ? '#FAFAFA' : 'inherit',
                  "&:hover": {
                    backgroundColor: isDisabled ? '#FAFAFA !important' : '#F0F7FF !important',
                    "& td": { backgroundColor: "inherit !important" },
                  },
                }}
                onClick={() => { if (row.id) window.open(`/discover/details/${row.id}`, '_blank'); }}
              >
                <TableCell component="td" scope="row">
                  <Stack direction={"row"} spacing={2}>
                    <div className="MuiAvatar-root MuiAvatar-circular" style={{ display: 'flex', width: 'fit-content', gap: '5px', justifyContent: 'center', alignItems: 'center' }}>
                      <img alt="" style={{ height: '35px', width: '35px', borderRadius: "100px" }} src={row.profilePicture || row.picture || "/profile.jpg"} className="MuiAvatar-img" />
                    </div>
                    <Box style={{ fontSize: '13px', paddingTop: 7, fontWeight: '500', letterSpacing: '0px', textTransform: 'capitalize', color: isDisabled ? '#9E9E9E' : '#0077FF' }}>
                      <Tooltip componentsProps={TOOLTIP_STYLES} title={row.fullName || row.username} arrow={true}>
                        <span>{(row.fullName || row.username || "Unknown")}</span>
                      </Tooltip>
                      {/* {row.source && (
                        <Chip
                          size="small"
                          label={row.source === 'local' ? 'LOCAL' : 'LIVE'}
                          sx={{
                            ml: 1,
                            height: '16px',
                            fontSize: '9px',
                            fontWeight: 700,
                            backgroundColor: row.source === 'local' ? '#E8F5E9' : '#FFF3E0',
                            color: row.source === 'local' ? '#2E7D32' : '#E65100'
                          }}
                        />
                      )} */}
                    </Box>
                  </Stack>
                </TableCell>
                
                <TableCell component="td" scope="row">{getFixedValue(followerCount) || "N/A"}</TableCell>
                
                <TableCell component="td" scope="row">{getFixedValue(avgLikes) || "0"}</TableCell>
                
                <TableCell align="left">{getFixedValue(avgViews) || "0"}</TableCell>
                
                {isYoutube && <TableCell align="left">{getFixedValue(avgComments) || "0"}</TableCell>}
                
                {isInstagram && <TableCell align="left">{(Number(er) || 0).toFixed(0) || "0"}</TableCell>}
                
                <TableCell align="left">
                  <Tooltip componentsProps={TOOLTIP_STYLES} title={locationStr} arrow={true}>
                    <span>{trunCateString(locationStr, 20) || "N/A"}</span>
                  </Tooltip>
                </TableCell>
              </TableRow>
              </Tooltip>
            );
          })}
        </TableBody>
      </Table>
    </Box>
  );
};

export default UltimateDiscoverResults;